export default __webpack_public_path__ + "static/media/content-loader.87797049.svg";